import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';

export const FullWidthWrapper = styled.div`
  position: relative;
  right: 50%;
  left: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  max-width: 100vw;
  width: 100vw;
`;

export const SmallContainer = styled.div`
  position: relative;
  margin-left: -38px;
  margin-right: -38px;

  @media (max-width: ${breakpoints.s}) {
    margin: 0;
  }
`;
